import type { Message, MessageType } from '@beacon/core';

import type { BeaconClient } from '../client.js';

export interface MessageListResponse {
  messages: Message[];
}

export interface SendMessageInput {
  type: Extract<MessageType, 'staff_email' | 'internal_note'>;
  bodyText: string;
  bodyHtml: string | null;
}

export const messagesApi = {
  list(
    client: BeaconClient,
    ticketNumber: string
  ): Promise<MessageListResponse> {
    return client.get<MessageListResponse>(
      `/api/tickets/${ticketNumber}/messages`
    );
  },

  /**
   * Send a message. When `files` is non-empty the request switches to
   * multipart/form-data so the bytes can travel alongside the text
   * fields; otherwise it falls back to JSON. Both shapes return the
   * same Message DTO so the calling cache logic doesn't branch.
   */
  send(
    client: BeaconClient,
    ticketNumber: string,
    input: SendMessageInput,
    files: ReadonlyArray<File> = []
  ): Promise<Message> {
    if (files.length === 0) {
      return client.post<Message>(
        `/api/tickets/${ticketNumber}/messages`,
        input
      );
    }
    const fd = new FormData();
    fd.set('type', input.type);
    fd.set('bodyText', input.bodyText);
    if (input.bodyHtml !== null && input.bodyHtml !== undefined) {
      fd.set('bodyHtml', input.bodyHtml);
    }
    for (const file of files) {
      fd.append('files', file, file.name);
    }
    return client.postRaw<Message>(
      `/api/tickets/${ticketNumber}/messages`,
      fd
    );
  },
};
